import React from 'react';
import { cn } from '@fshr/shared-react';

interface ChevronDownProps {
	className?: string;
}

const IconChevronDown: React.FC<ChevronDownProps> = ({ className }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			className={cn('w-full h-full', className)}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 4L8 12L16 4H14.4L8 10.4L1.6 4H0Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default IconChevronDown;
